import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { Platform } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;
  private storageReady = new BehaviorSubject<boolean>(false);

  constructor(
    private storage: Storage,
    private platform: Platform
  ) {
    this.init();
  }

  async init() {
    // Esperar a que la plataforma esté lista
    await this.platform.ready();

    try {
      // Crear la instancia del storage
      this._storage = await this.storage.create();
      this.storageReady.next(true);
      console.log('Storage initialized successfully');
    } catch (error) {
      console.error('Error initializing storage:', error);
      // Reintentar después de un delay
      setTimeout(() => {
        this.init();
      }, 2000);
    }
  }

  // Método para verificar si el storage está listo
  isReady(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.storageReady.value) {
        resolve(true);
      } else {
        this.storageReady.subscribe(ready => {
          if (ready) {
            resolve(true);
          }
        });
      }
    });
  }

  // Métodos wrapper para el storage
  async get(key: string): Promise<any> {
    await this.isReady();
    return this._storage?.get(key);
  }

  async set(key: string, value: any): Promise<void> {
    await this.isReady();
    return this._storage?.set(key, value);
  }

  async remove(key: string): Promise<void> {
    await this.isReady();
    return this._storage?.remove(key);
  }

  async clear(): Promise<void> {
    await this.isReady();
    return this._storage?.clear();
  }

  async keys(): Promise<string[]> {
    await this.isReady();
    return this._storage?.keys() || [];
  }

  async length(): Promise<number> {
    await this.isReady();
    return this._storage?.length() || 0;
  }
}